<header class="c-header {{#if searchOpened }} disabled {{/if}} {{#if additionalClasses}}{{additionalClasses}}{{/if}}">
		<nav class="navbar navbar-default {{!actualPath || useWhiteLogos ? 'navbar-filled' : ''}}">
		<div class="container-fluid container-mw">
			<div class="navbar-header">
				<a class="main-logo" href="/" on-click="@this.fire('main-logo-click')">
					<!--
						Looking for the logo?
						Get all versions here: https://github.com/jsdelivr/jsdelivr-media
					-->
					{{#if actualPath && actualPath.startsWith('/package/')}}
						<img width="29" height="32" src="{{@shared.assetsHost}}/img/icons/jsdelivr_icon.svg" title="jsDelivr">
					{{elseif actualPath && actualPath.startsWith('/docs/data.jsdelivr.com')}}
						<img width="140" height="34" src="{{@shared.assetsHost}}/img/jsdelivr-horizontal-white.svg" title="jsDelivr">
					{{elseif actualPath && useWhiteLogos}}
						<img width="140" height="34" src="{{@shared.assetsHost}}/img/jsdelivr-horizontal-full-white.svg" title="jsDelivr">
					{{elseif actualPath}}
						<img width="140" height="34" src="{{@shared.assetsHost}}/img/jsdelivr-horizontal-regular.svg" title="jsDelivr">
					{{/if}}
				</a>

				{{#if actualPath && actualPath.includes('/package/')}}
					{{yield}}
				{{/if}}

				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#main-navbar" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
			</div>

			<div class="collapse navbar-collapse" id="main-navbar">
				<ul class="nav navbar-nav navbar-right {{!actualPath ? 'navbar-hidden' : useWhiteLogos ? 'about-navbar-right' : 'default-navbar-right'}}">
					<li><a href="/about">About Us</a></li>
					<li><a href="/network">Network</a></li>
					<li><a href="/statistics">Stats</a></li>
					<li><a href="/sponsors">Sponsors</a></li>
					<li class="dropdown">
						<a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
							Tools <i class="fa fa-angle-down" aria-hidden="true"></i>
						</a>
						<ul class="dropdown-menu">
							<li><a href="/tools/purge">Purge cache</a></li>
							<li role="separator" class="divider"></li>
							<li class="dropdown-header"><div>Convert from</div></li>
							<li><a href="/github">GitHub</a></li>
							<li><a href="/google">Google Hosted Libraries</a></li>
							<li><a href="/unpkg">unpkg</a></li>
							<li><a href="/skypack">Skypack</a></li>
							<li><a href="/esmsh">esm.sh</a></li>
						</ul>
					</li>
					<li class="dropdown">
						<a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
							Resources <i class="fa fa-angle-down" aria-hidden="true"></i>
						</a>
						<ul class="dropdown-menu">
							<li><a target="_blank" href="/blog/" class="router-ignore">Blog <i class="fa fa-external-link" aria-hidden="true"></i></a></li>
							<li><a target="_blank" rel="noopener noreferrer" href="https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736">Newsletter <i class="fa fa-external-link" aria-hidden="true"></i></a></li>
							<li><a href="/esm">esm.run</a></li>
							<li class="dropdown-header"><div>Documentation</div></li>
							<li><a href="/documentation">Open Source CDN</a></li>
							<li><a href="/docs/data.jsdelivr.com" class="router-ignore">Public API</a></li>
						</ul>
					</li>
					<li><a href="https://globalping.io" target="_blank">Globalping<i class="fa fa-external-link"></i></a></li>
					<li>
						<a target="_blank" rel="noopener noreferrer" href="https://github.com/jsdelivr/jsdelivr" title="GitHub">
							<i class="fa fa-github" aria-hidden="true"></i>
							<span class="icon-label-mobile">GitHub</span>
						</a>
					</li>
					<li>
						<a target="_blank" rel="noopener noreferrer" href="https://twitter.com/jsDelivr" title="Twitter">
							<i class="fa fa-twitter" aria-hidden="true"></i>
							<span class="icon-label-mobile">Twitter</span>
						</a>
					</li>
					<li>
						<a target="_blank" rel="noopener noreferrer" href="/discord" title="Discord" class="router-ignore">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="14" height="14" style="margin-top: 1px;" class="fa" title="Discord">
								<path fill="{{#if useWhiteLogos}}#fff{{else}}#17233b{{/if}}" d="M524.531 69.836a1.5 1.5 0 0 0-.764-.7A485.065 485.065 0 0 0 404.081 32.03a1.816 1.816 0 0 0-1.923.91 337.461 337.461 0 0 0-14.9 30.6 447.848 447.848 0 0 0-134.426 0 309.541 309.541 0 0 0-15.135-30.6 1.89 1.89 0 0 0-1.924-.91 483.689 483.689 0 0 0-119.688 37.107 1.712 1.712 0 0 0-.788.676C39.068 183.651 18.186 294.69 28.43 404.354a2.016 2.016 0 0 0 .765 1.375 487.666 487.666 0 0 0 146.825 74.189 1.9 1.9 0 0 0 2.063-.676A348.2 348.2 0 0 0 208.12 430.4a1.86 1.86 0 0 0-1.019-2.588 321.173 321.173 0 0 1-45.868-21.853 1.885 1.885 0 0 1-.185-3.126 251.047 251.047 0 0 0 9.109-7.137 1.819 1.819 0 0 1 1.9-.256c96.229 43.917 200.41 43.917 295.5 0a1.812 1.812 0 0 1 1.924.233 234.533 234.533 0 0 0 9.132 7.16 1.884 1.884 0 0 1-.162 3.126 301.407 301.407 0 0 1-45.89 21.83 1.875 1.875 0 0 0-1 2.611 391.055 391.055 0 0 0 30.014 48.815 1.864 1.864 0 0 0 2.063.7A486.048 486.048 0 0 0 610.7 405.729a1.882 1.882 0 0 0 .765-1.352c12.264-126.783-20.532-236.912-86.934-334.541ZM222.491 337.58c-28.972 0-52.844-26.587-52.844-59.239s23.409-59.241 52.844-59.241c29.665 0 53.306 26.82 52.843 59.239 0 32.654-23.41 59.241-52.843 59.241Zm195.38 0c-28.971 0-52.843-26.587-52.843-59.239s23.409-59.241 52.843-59.241c29.667 0 53.307 26.82 52.844 59.239 0 32.654-23.177 59.241-52.844 59.241Z"/>
							</svg>
							<span class="icon-label-mobile">Discord</span>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</header>

<script>
	component.exports = {
		oninit () {
			if (Ractive.isServer) {
				this.set('actualPath', this.root.get('actualPath'));
			} else {
				this.set('actualPath', this.get('@shared')?.app?.router?.uri?.path);
			}
		},
	};
</script>
